<template>
  <div class="checkin-step1">
    <div class="checkin-form-wrap clearfix">
      <div class="form-wrap">
        <checkin-form @callback="checkIn"></checkin-form>
      </div>
      <div class="code-wrap" v-if="checkinQRcode" v-html="checkinQRcode"></div>
    </div>
    <div class="rule-wrap">
      <rule></rule>
    </div>
  </div>
</template>
<script>
import CheckinForm from '@/components/checkin/checkinForm'
import Rule from '@/components/checkin/rule'
export default {
  components: {
    CheckinForm,
    Rule
  },
  data () {
    return {
      checkinQRcode: ''
    }
  },
  created () {
    this.getCmsData()
  },
  methods: {
    checkIn (data) {
      this.$emit('callback', 2, data)
    },
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { content } = res?.checkinQRcode
          this.checkinQRcode = content || ''
        })
      } catch (err) {}
    }
  }
}
</script>
<style lang="less" scoped>
.checkin-step1 {
  .checkin-form-wrap {
    width: 640px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
  }
  .form-wrap {
    width: 388px;
  }
  .code-wrap {
    width: 190px;
    margin-left: 60px;
    img {
      width: 190px;
      height: 217px;
    }
    .text {
      text-align: center;
      font-size: 12px;
      line-height: 1;
      color: #808080;
      margin-top: 20px;
    }
  }
  .rule-wrap {
    margin-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  .checkin-step1 {
    .form-wrap {
      width: 100%;
      float: none;
    }
    .code-wrap {
      float: none;
      margin: 0 auto;
    }
    .checkin-form-wrap {
      width: 96%;
    }
    .rule-wrap {
      width: 94%;
      margin: 0 auto;
      margin-top: 30px;
    }
  }
}
</style>
